import parsePhoneNumber from 'libphonenumber-js';

/** Formats a phone number for display, falling back to the raw value. */
export function formatPhone(phone: string): string {
    try {
        const phoneNumber = parsePhoneNumber(phone);
        if (phoneNumber && phoneNumber.isValid()) {
            return phoneNumber.formatInternational();
        }
    } catch {
        // Fall through to the raw number
    }

    return phone;
}
